import type { ObjectValues } from '@sats-group/ui-lib/react/types';
import type { ContentContainer } from '../content-container/content-container.types';

export const themes = {
  light: 'light',
  fixed: 'fixed',
} as const;

export type Breadcrumbs = {
  theme?: ObjectValues<typeof themes>;
  landmarkLabel: string;
  links: { href?: string; text: string }[];
  title: string;
  width?: ContentContainer['theme'];
};
